interface DeferredResourcePollDelayInput {
  initialDelayMs: number;
  attempt: number;
  factor?: number;
  maxDelayMs?: number;
}

const DEFAULT_BACKOFF_FACTOR = 2;
const DEFAULT_MAX_POLL_DELAY_MS = 10_000;

export function getDeferredResourcePollDelay({
  initialDelayMs,
  attempt,
  factor = DEFAULT_BACKOFF_FACTOR,
  maxDelayMs = DEFAULT_MAX_POLL_DELAY_MS,
}: DeferredResourcePollDelayInput): number {
  const exponentialDelayMs = initialDelayMs * factor ** attempt;

  return Math.min(exponentialDelayMs, maxDelayMs);
}
